import React, { Component } from 'react'

import style from './Grid.css'

export default class AlignSM extends Component {
  render() {
    return (
      <div
        {...this.props}
        className={`${(this.props.text) ? style['text-'+this.props.text+'SM'] : ''} ${this.props.className || ''}`}
        style={{
          ...this.props.style
        }}
        >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/Footer/Grid/AlignSM.js